const buildLinkedDataTs = (storeConf, ratingValue, ratingCount) => {
  if (!storeConf || !ratingValue || !ratingCount) {
    return '';
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: storeConf.store_name,
    brand: storeConf.store_name,
    url: storeConf.url,
    logo: storeConf.logo,
    image: storeConf.image,
    description: storeConf.description,
    aggregateRating: {
      '@type': 'AggregateRating',
      bestRating: '5.00',
      ratingValue: ratingValue,
      ratingCount: ratingCount,
    },
  };
};

export default buildLinkedDataTs;
